import React from 'react';
import { HStack, Heading, Status } from '@chakra-ui/react';


const JobStatus = ({ status  }) => {
  // Pending -> Blue
  // Error -> Red
  // Completed -> Green

  let color = null;
  if (status === 'Pending') {
    color = 'gray';
  }else if (status === 'Error') {
    color = 'red';
  }else if (status === 'Running') {
    color = 'blue';
  }else if (status === 'Completed') {
    color = 'green';
  }
    
  return (
    <Status.Root colorPalette={color}> 
      <Status.Indicator /> 
      {status} 
    </Status.Root>
  );
};

export default JobStatus;